// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3LLUF","selects":"Documents_selects__837lc"};